<template>
  <div class="maxh-1bar scroll-y pa-3 d-flex">
    <div class="w-1/2 pa-3 d-flex flex-column">
      <v-card>
        <EditDetailsDialog ref="editDialog" />

        <ODialogBar no-close title="Configurações Gerais">
          <v-spacer />
          <v-btn small @click="refreshToken">Refresh token</v-btn>
          <v-btn icon @click="startEdit">
            <v-icon>mdi-pencil</v-icon>
          </v-btn>
        </ODialogBar>
        <v-card-text class="pa-3 d-flex flex-wrap">
          <OCapCont class="w-1/2 pa-3" label="Label" :value="value.label" />
          <OCapCont class="w-1/2 pa-3" label="Código" :value="value.name" />

          <OCapCont class="w-1/2 pa-3" label="Tags">
            <OTagList :value="extraInfo.tags" />
          </OCapCont>
        </v-card-text>
        <v-divider />
        <v-card-text class="pa-3 d-flex flex-wrap">
          <OCapCont class="w-full pa-3" label="IP/Porta">
            {{ extraInfo.internalIp }} : {{ extraInfo.internalPort }}
          </OCapCont>

          <OCapCont
            class="w-full pa-3"
            label="Return Token"
            :value="value.returnToken"
          />

          <div class="w-full d-flex items-end">
            <OCapCont class="pa-3" label="Database">
              {{ dbPieces.user }} : {{ dbPieces.host }}
              <v-btn icon @click="copyDatabase">
                <v-icon small>mdi-content-copy</v-icon>
              </v-btn>
            </OCapCont>
          </div>
        </v-card-text>
      </v-card>

      <OrgStatusRelays class="mt-6" :org="value" @reload="$emit('reload')" />
    </div>

    <div class="w-1/2 pa-3 d-flex flex-column">
      <OrgTokens :org="value" />

      <OrgConfigYaml class="mt-6" :org="value" />
    </div>
  </div>
</template>

<script>
import utils from 'oderon-commons/src/utils.js'
import OrgTokens from './OrgTokens.vue'
import OrgConfigYaml from './OrgConfigYaml.vue'
import EditDetailsDialog from './EditDetailsDialog.vue'
import OrgStatusRelays from './OrgStatusRelays.vue'
import { Org } from '@/models/index'

export default {
  expose: ['reload'],
  tabTitle: 'Configuração',
  components: { OrgTokens, OrgConfigYaml, EditDetailsDialog, OrgStatusRelays },
  props: {
    value: { required: true }
  },
  computed: {
    extraInfo() {
      return this.value.extraInfo || {}
    },
    dbPieces() {
      let str = this.value.database
      if (utils.isEmpty(str)) return {}

      let m = str.match(/^mysql:\/\/([^:]+):[^@]+@([^/]+)\/(.+)$/)
      if (m == null) return {}
      return {
        user: m[1],
        host: m[2],
        schema: m[3]
      }
    }
  },
  methods: {
    async startEdit() {
      let res = await this.$refs.editDialog.open(this.value.id)
      if (res === true) {
        this.$emit('reload')
      }
    },

    copyDatabase() {
      navigator.clipboard.writeText(this.value.database)
      this.$snack('Copied to clipboard')
    },

    async refreshToken() {
      let rootPassword = await this.$prompt({
        label: 'Informe a senha ATUAL do root na org:'
      })

      if (rootPassword != null) {
        let res = await Org.refreshToken(this.value.id, rootPassword)
        this.$info({
          message: `
            Resultado: ${res.result}<br/>
            User: ${res.user}<br/>
            Had token: ${res.hadToken}<br/>
            Got token: ${res.gotToken}
          `
        })
      }
    }
  }
}
</script>

<style></style>
